export const loginConstants = {
  GET_EMAIL_VERIFIED: "GET_EMAIL_VERIFIED",
  GET_OTP_dETAIL: "GET_OTP_dETAIL",
  GET_OTP_VERIFIED: "GET_OTP_VERIFIED",
  USER__DETAIL: "USER_DETAIL",
  SET_USER_LOGOUT: "SET_USER_LOGOUT",
};
